import { defineStore } from 'pinia';

export const useCartorioStore = defineStore('cartorio', {
  state: () => ({
    cartorioAtual: null,
    isLoading: false,
    error: null
  }),

  getters: {
    cnsAtual: (state) => state.cartorioAtual?.cns || null,
    nomeCartorio: (state) => state.cartorioAtual?.nome || '',
    funcaoCartorio: (state) => state.cartorioAtual?.funcao || ''
  },

  actions: {
    setCartorio(cartorio) {
      this.cartorioAtual = cartorio;
      if (cartorio) {
        localStorage.setItem('cartorio', JSON.stringify(cartorio));
        // Remover flag de permissão se função for permitida
        if (this.verificarPermissaoFuncao(cartorio.funcao)) {
          sessionStorage.removeItem('semPermissaoToast');
        }
      } else {
        localStorage.removeItem('cartorio');
      }
      this.error = null;
    },

    async trocarCartorio(novoCartorio) {
      try {
        //console.log('Store: Iniciando troca de cartório:', novoCartorio);
        this.isLoading = true;
        this.error = null;
        
        if (!this.validarDadosCartorio(novoCartorio)) {
          throw new Error('Dados do cartório inválidos');
        }

        this.setCartorio(novoCartorio);
        //console.log('Store: Cartório definido:', this.cartorioAtual);
        
        // Emitir evento para notificar componentes
        window.dispatchEvent(new CustomEvent('cartorio-alterado', {
          detail: novoCartorio
        }));
        //console.log('Store: Evento cartório-alterado emitido');

        return true;
      } catch (error) {
        console.error('Store: Erro ao trocar cartório:', error);
        this.error = error.message;
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    carregarCartorioDoStorage() {
      try {
        //console.log('Store: Carregando cartório do storage');
        const cartorioData = localStorage.getItem('cartorio');
        if (cartorioData) {
          const cartorio = JSON.parse(cartorioData);
          if (this.validarDadosCartorio(cartorio)) {
            this.cartorioAtual = cartorio;
            //console.log('Store: Cartório carregado do storage:', this.cartorioAtual);
            return true;
          }
        }
        //console.log('Store: Nenhum cartório válido encontrado no storage');
        return false;
      } catch (error) {
        console.error('Store: Erro ao carregar cartório do storage:', error);
        return false;
      }
    },

    validarDadosCartorio(cartorio) {
      return cartorio && 
             typeof cartorio === 'object' && 
             cartorio.cns && 
             typeof cartorio.cns === 'string' && 
             cartorio.cns.trim().length > 0 &&
             cartorio.nome && 
             typeof cartorio.nome === 'string' &&
             cartorio.funcao && 
             typeof cartorio.funcao === 'string';
    },

    verificarPermissaoFuncao(funcao) {
      return funcao === 'Oficial' || funcao === 'Substituto' || funcao === 'Preposto' || funcao === 'Escrevente'; // Função substituto não tem permissão  || funcao === 'Substituto'
    },

    limparCartorio() {
      this.cartorioAtual = null;
      this.error = null;
      localStorage.removeItem('cartorio');
    }
  }
});